(function ($) {
  function interceptCartAddRequests() {
    if (window.__cpbDisclaimerFetchPatched) return;
    window.__cpbDisclaimerFetchPatched = true;

    const originalFetch = window.fetch;

    window.fetch = async function (input, init) {
      try {
        const url =
          typeof input === "string"
            ? input
            : input && typeof input.url === "string"
            ? input.url
            : "";

        if (url.includes("/cart/add.js") && init && init.body) {
          let bodyObject = null;

          try {
            bodyObject = JSON.parse(init.body);
          } catch (e) {}

          if (bodyObject) {
            const tags = await loadProductTagsFromShopify();
            const isDisclaimerProduct =
              Array.isArray(tags) && tags.includes("Disclaimer");

            if (isDisclaimerProduct && Array.isArray(bodyObject.items)) {
              bodyObject.items.forEach((item, index) => {
                if (!item.properties) item.properties = {};
                item.properties["Disclaimer"] =
                  "Accepted during product customization";
              });

              init.body = JSON.stringify(bodyObject);
            }
          }
        }
      } catch (e) {
        console.error("[CPB DISCLAIMER] fetch intercept error:", e);
      }

      return originalFetch.apply(this, arguments);
    };
  }
  interceptCartAddRequests();

  async function duscounts() {
    let showDesignerDiscounts;
    let showWholesaleDiscounts;
    let cartTotalPrice = 0;
    let buildTotalPrice = 0;
    try {
      showDesignerDiscounts = productTags.designer;
      showWholesaleDiscounts =
        productTags.wholesale && productTags.bundle === false;
    } catch (e) {
      return;
    }
    if (!!showDesignerDiscounts === false && !!showWholesaleDiscounts === false)
      return;
    const discountPriceContainers = [];
    $(".cpb-product-full-price").each(() => {
      discountPriceContainers.push(
        $('<div class="cpb-custom-discounted-price">')
      );
    });
    updateCartPrice();
    document.addEventListener("cpb-add-to-cart", updateCartPrice);
    updateBuildPrice();
    document.body.addEventListener("CPB_ON_OPTIONS_UPDATE", updateBuildPrice);
    $(document).on("mousedown, click", ".cpb-quantity-button", () => {
      setTimeout(updateBuildPrice, 1000);
    });

    function getDesignerDiscountPercent() {
      return cartTotalPrice + buildTotalPrice * 0.8 >= 10000 ? 20 : 0;
    }
    function getFullDiscountPercent() {
      let wholesaleDiscountPercent =
        cartTotalPrice + buildTotalPrice * 0.6 >= 80000 ? 40 : 0;
      return Math.max(getDesignerDiscountPercent(), wholesaleDiscountPercent);
    }
    function onPriceChange() {
      recountDiscounts();
    }
    function recountDiscounts() {
      let discountPercent = 0;
      if (showWholesaleDiscounts) discountPercent = getFullDiscountPercent();
      else discountPercent = getDesignerDiscountPercent();
      const discountedPriceNumber =
        Math.round(
          buildTotalPrice - (buildTotalPrice / 100) * discountPercent
        ) / 100;
      $(".cpb-product-full-price").each(function (i) {
        discountPriceContainers[i].text("$" + discountedPriceNumber.toFixed(2));
        discountPriceContainers[i].toggleClass(
          "cpb-custom-has-discount",
          discountPercent > 0
        );
        const price = $(this);
        price.toggleClass(
          "cpb-custom-price-before-discount",
          discountPercent > 0
        );
        price.append(discountPriceContainers[i]);
      });
    }
    function updateBuildPrice() {
      const newPrice = CPB.getStore().getState().Product.price * 100;
      console.log("update build price", newPrice, buildTotalPrice);
      if (buildTotalPrice === newPrice) return;
      buildTotalPrice = newPrice;
      onPriceChange();
    }
    async function updateCartPrice() {
      const productsInCartResponse = await fetch("/cart.js");
      const productsInCart = await productsInCartResponse.json();
      cartTotalPrice = productsInCart.total_price;
      onPriceChange();
    }
  }

  const changeLoaderImage = {
    init() {
      setTimeout(this.changeLoaderImage, 60000);
      document.body.addEventListener(
        "CPB_ON_OPTIONS_UPDATE",
        () => {
          setTimeout(this.changeLoaderImage, 10000);
        },
        { once: true }
      );
      document
        .querySelector(".cpb-add-to-cart-button")
        ?.addEventListener("click", this.changeLoaderImage);
    },
    changeLoaderImage: (function () {
      let changed = false;
      return function () {
        if (changed) return;
        changed = true;
        const style = document.createElement("style");
        style.setAttribute("data-custom-added-by-cpb", "");
        const addToCartImageUrl =
          "https://cdn.shopify.com/s/files/1/0219/0619/4532/t/82/assets/adding_to_cart.gif?v=1662663880";
        style.innerText =
          ".cpb-loader-center::before {background-image: url(" +
          addToCartImageUrl +
          ")}";
        document.body.appendChild(style);
      };
    })(),
  };

  document.body.addEventListener("CPB_ON_PRODUCT_MOUNTED", init);
  document.addEventListener("cpb-add-to-cart", function (event) {
    const drawer = new theme.CartDrawer();
    drawer.open();
  });

  const saveImageUrl = "https://api.thecustomproductbuilder.com/imageUpload/";
  async function saveImage(fileData) {
    const splitted = fileData.split(";base64,");
    const imageType = splitted[0].replace("data:", "");
    const data = {
      shopId: CPB.getStore().getState().App.shop.id,
      "file[mimetype]": imageType,
      "file[buffer]": splitted[1],
      "file[originalname]":
        (Math.random() + 1).toString(36).substring(2) +
        (Math.random() + 1).toString(36).substring(2) +
        "." +
        imageType.split("/")[1],
    };
    return new Promise((res) => {
      $.post(saveImageUrl, data, (data) => res(data));
    });
  }
  function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
    if (uri.match(re)) {
      return uri.replace(re, "$1" + key + "=" + value + "$2");
    } else {
      var hash = "";
      if (uri.indexOf("#") !== -1) {
        hash = uri.replace(/.*#/, "#");
        uri = uri.replace(/#.*/, "");
      }

      var separator = uri.indexOf("?") !== -1 ? "&" : "?";
      return uri + separator + key + "=" + value + hash;
    }
  }
  function getViewImageURL(size, view) {
    if (typeof window.cpbImageStorage === "undefined") return;
    view = view || "front";
    size = size || 1000;
    var convaSize = $(".konvajs-content").width() || size;
    var newRatio = size / convaSize;
    var getDataURL = cpbImageStorage.views[view].getSnapshot(newRatio);
    return getDataURL;
  }

  function myRegistry(customAddToCart) {
    if (!!customAddToCart === false) return;
    if (!!window.MyRegistrySDK === false) return;
    const addToCart = $(".cpb-add-to-cart-button").last();
    const registryBtn = $(
      '<button type="button" class="cpbc-my-registry-btn">Add To Registry</button>'
    ).on("click", () => {
      customAddToCart.setCartFunction(async (data) => {
        const item = data.items[0];
        const configId = item.properties._configId;
        const url = updateQueryStringParameter(
          window.location.href,
          "configid",
          configId
        );
        const imageUrl = item.properties._image;
        const gift = {
          Title: CPB.getStore().getState().Product.name,
          ImageUrl: imageUrl,
          URL: url,
          Price: +CPB.getStore().getState().Product.price,
          Quantity: CPB.getStore().getState().Product.quantity,
        };
        const registry = new window.MyRegistrySDK(gift);
        registry.showPopup();
        customAddToCart.setDefaultCartFunction();
      });
      addToCart.trigger("click");
    });
    addToCart.after(registryBtn);
    new MutationObserver(() => {
      if (!document.getElementById("myregistry_embed_view"))
        return console.log("stoped"); // added to make mobile menu work and finish appearing animation
      if (document.documentElement.classList.contains("js-drawer-closing")) {
        document.documentElement.classList.remove("js-drawer-closing");
      }
      if (document.documentElement.classList.contains("js-drawer-open")) {
        document.documentElement.classList.remove("js-drawer-open");
        document.documentElement.classList.remove("lock-scroll");
      }
    }).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }
  const PJSteps = (() => {
    const TARGET_NAME =
      "Branded Glass Soap Bottle With Logo | Signature Collection-Copy";
    const INIT_FLAG = "__pjStepsInited";
    const EVENTS_BOUND_FLAG = "__pjStepsEventsBound";

    const STEP_META_KEYS = [
      { namespace: "custom", key: "stepKey" },
      { namespace: "cpb", key: "stepKey" },
      { namespace: "", key: "stepKey" },
    ];
    const STEP_ORDER_META_KEYS = [
      { namespace: "custom", key: "stepOrder" },
      { namespace: "cpb", key: "stepOrder" },
      { namespace: "", key: "stepOrder" },
    ];
    const STEP_LABEL_META_KEYS = [
      { namespace: "custom", key: "stepLabel" },
      { namespace: "cpb", key: "stepLabel" },
      { namespace: "", key: "stepLabel" },
    ];
    const ICON_META_KEYS = [
      { namespace: "custom", key: "custom-icon-svg" },
      { namespace: "cpb", key: "custom-icon-svg" },
      { namespace: "", key: "custom-icon-svg" },
    ];

    const SUMMARY_STEP = {
      key: "summary",
      label: "Add to cart",
      order: 9999,
      iconUrl:
        "https://cdn.shopify.com/s/files/1/0219/0619/4532/files/cartSvg.png?v=1776199565",
    };

    let state = null;
    let root = null;
    let categoriesContainer = null;
    let observer = null;

    function log(...args) {
      console.log("[PJ]", ...args);
    }

    function normalizeText(s) {
      return (s || "")
        .replace(/\u00A0/g, " ")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
    }

    function escapeHtml(s) {
      return String(s)
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#039;");
    }

    function escapeAttr(s) {
      return escapeHtml(s).replaceAll(" ", "_");
    }

    function escapeUrlAttr(s) {
      return String(s)
        .replaceAll("&", "&amp;")
        .replaceAll('"', "&quot;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;");
    }

    function humanizeStepKey(key) {
      return String(key || "")
        .replace(/[_-]+/g, " ")
        .replace(/\b\w/g, (m) => m.toUpperCase());
    }

    function getProductName() {
      const st = CPB?.getStore?.().getState?.();
      return (st?.Product?.name || "").trim();
    }

    function isTargetProduct() {
      const name = getProductName();
      log("check name:", name);
      return name === TARGET_NAME;
    }

    function hasAnyStepMetafields() {
      const st = CPB?.getStore?.().getState?.();
      const cats = st?.Product?.panels?.[0]?.categories;
      if (!Array.isArray(cats)) return false;

      return cats.some((cat) => {
        const mfs = cat?.metafields;
        if (!Array.isArray(mfs)) return false;
        return !!getMetaValue(mfs, STEP_META_KEYS);
      });
    }

    function ensureFrameMounted() {
      const panels = root.querySelector(".cpb-panels-container") || root;
      const h1 = panels.querySelector("h1.cpb-product-title");
      if (!h1) return;

      if (panels.querySelector(".pj-frame")) return;

      const frame = document.createElement("div");
      frame.className = "pj-frame";

      let node = h1.nextSibling;
      const toMove = [];
      while (node) {
        const next = node.nextSibling;
        if (!(node.nodeType === 3 && !node.textContent.trim()))
          toMove.push(node);
        node = next;
      }

      panels.appendChild(frame);
      toMove.forEach((n) => frame.appendChild(n));
    }

    function getCurrentPriceText() {
      const el =
        root.querySelector('[data-testid="multycurrency-price"]') ||
        root.querySelector(".cpb-product-price") ||
        root.querySelector('[class*="price"]');
      return (el?.textContent || "").trim();
    }

    function updateStepsInfoUI() {
      const titleEl = root.querySelector(".pj-steps-title");
      const priceEl = root.querySelector(".pj-steps-price");
      if (!titleEl || !priceEl) return;

      const idx = getCurrentStepIndex();
      const keys = getStepKeysInOrder();
      const isSummary = state.currentStepKey === SUMMARY_STEP.key;

      const stepNum = idx >= 0 ? idx + 1 : 1;

      const stepObj = state.steps.find((s) => s.key === state.currentStepKey);
      const stepLabel = stepObj?.label || humanizeStepKey(state.currentStepKey);

      titleEl.textContent = `Step ${stepNum}: ${stepLabel}`;
      priceEl.textContent = getCurrentPriceText();
    }

    function ensureActionsDividerMounted() {
      const actions = document.querySelector(".cpb-product-actions");
      if (!actions) return;

      if (
        actions.previousElementSibling?.classList?.contains(
          "pj-actions-divider"
        )
      )
        return;

      const div = document.createElement("div");
      div.className = "pj-actions-divider";
      actions.parentElement.insertBefore(div, actions);
    }

    function init() {
      try {
        if (!hasAnyStepMetafields()) return;
        document.body.classList.add("pj-steps-enabled");
        if (window[INIT_FLAG]) return;
        window[INIT_FLAG] = true;

        log("init steps");
        mount();
      } catch (e) {
        console.error("[PJ] init error:", e);
      }
    }

    function mount() {
      root = document.querySelector("#product-builder");
      if (!root) return;

      categoriesContainer =
        root.querySelector(".cpb-panel-categories-container.col-tabs") ||
        root.querySelector(".cpb-panel-categories-container");

      if (!categoriesContainer) return;

      state = {
        steps: [],
        currentStepKey: null,

        stepsUnlocked: false,

        domById: new Map(),

        storeById: new Map(),

        stepMap: new Map(),

        categories: [],

        iconCache: new Map(),
      };

      ensureFrameMounted();
      ensureStepBarMounted();

      rebuildAndApply();

      observer = new MutationObserver(() => {
        rebuildAndApply();
      });
      observer.observe(categoriesContainer, { childList: true });

      bindEventsOnce();
      ensureActionsDividerMounted();

      let tries = 0;
      const navTimer = setInterval(() => {
        tries += 1;
        const ok = ensureNavButtonsMounted();
        if (ok || tries > 50) {
          clearInterval(navTimer);
          updateNavButtonsUI();
          updateActionsVisibility();
        }
      }, 100);
    }

    function ensureStepBarMounted() {
      if (root.querySelector(".pj-steps")) return;

      const bar = document.createElement("div");
      bar.className = "pj-steps";
      bar.innerHTML = `
            <div class="pj-steps-info">
              <div class="pj-steps-text">
              <div class="pj-steps-title"></div>
              <div class="pj-steps-sub"></div>
            </div>
            <div class="pj-steps-price"></div>
            </div>
            <div class="pj-steps-buttons"></div>
            `;

      bar.addEventListener("click", (e) => {
        const btn = e.target.closest("button[data-step-key]");
        if (!btn) return;
        setStep(btn.dataset.stepKey);
      });

      const wrapper = root.querySelector(".cpb-panel-wrapper");
      const fallback = root.querySelector(".cpb-panels-container") || root;
      const mountRoot = wrapper || fallback;

      let stepsImg = null;
      if (wrapper) {
        const imgs = Array.from(wrapper.querySelectorAll("img"));
        stepsImg =
          imgs.find((img) => (img.alt || "").toLowerCase().includes("step")) ||
          imgs.find((img) => (img.src || "").toLowerCase().includes("step")) ||
          null;
      }

      if (stepsImg && stepsImg.parentElement) {
        stepsImg.parentElement.insertBefore(bar, stepsImg);
      } else {
        mountRoot.prepend(bar);
      }
    }

    async function preloadStepIcons() {
      const urls = (state.steps || []).map((s) => s.iconUrl).filter(Boolean);

      const unique = Array.from(new Set(urls)).filter(
        (u) => !state.iconCache.has(u)
      );

      await Promise.all(
        unique.map(async (url) => {
          try {
            const res = await fetch(url, { cache: "force-cache" });
            const contentType = res.headers.get("content-type") || "";

            if (!contentType.includes("image/svg+xml")) {
              state.iconCache.set(url, null);
              return;
            }

            const txt = await res.text();

            let clean = txt
              .replace(/fill="(?!none)[^"]*"/gi, 'fill="currentColor"')
              .replace(/stroke="(?!none)[^"]*"/gi, 'stroke="currentColor"');

            state.iconCache.set(url, clean);
          } catch (e) {
            state.iconCache.set(url, null);
          }
        })
      );
    }

    function renderStepBar() {
      const buttonsRoot = root.querySelector(".pj-steps-buttons");
      if (!buttonsRoot) return;

      const steps = state.steps || [];
      buttonsRoot.innerHTML = steps
        .map((s, i) => {
          const url = s.iconUrl || "";
          const svg = url ? state.iconCache.get(url) : null;

          const iconHtml = svg
            ? `<span class="pj-step-icon pj-step-icon--svg">${svg}</span>`
            : url
            ? `<span class="pj-step-icon"><img src="${escapeUrlAttr(
                url
              )}" alt="" /></span>`
            : "";

          const numHtml = `<span class="pj-step-num">${i + 1}</span>`;

          const btnHtml = `
            <button type="button" data-step-key="${escapeAttr(s.key)}">
              ${numHtml}
              ${iconHtml}
              <span class="pj-step-label">${escapeHtml(s.label)}</span>
            </button>
          `;

          const arrowHtml =
            i < steps.length - 1 ? `<span class="pj-step-arrow">→</span>` : "";

          return btnHtml + arrowHtml;
        })
        .join("");

      updateStepButtonsUI();
      updateStepsInfoUI();
    }

    function getFirstNonSummaryStepKey() {
      const first = state.steps.find((s) => s.key !== SUMMARY_STEP.key);
      return first ? first.key : null;
    }

    function setStep(stepKey) {
      const firstKey = getFirstNonSummaryStepKey();

      if (!state.stepsUnlocked && stepKey !== firstKey) return;

      if (!state.stepMap.has(stepKey) && stepKey !== SUMMARY_STEP.key) return;

      state.currentStepKey = stepKey;
      applyStep();
    }

    function updateStepButtonsUI() {
      const bar = root.querySelector(".pj-steps");
      if (!bar) return;

      const firstKey = getFirstNonSummaryStepKey();

      bar.querySelectorAll("button[data-step-key]").forEach((btn) => {
        const key = btn.dataset.stepKey;

        btn.classList.toggle("is-active", key === state.currentStepKey);

        const lockedByBottle = !state.stepsUnlocked && key !== firstKey;

        const emptyNow = key !== firstKey && !isStepCurrentlyRenderable(key);

        const disabled = lockedByBottle || emptyNow;

        btn.classList.toggle("is-disabled", disabled);
        btn.disabled = disabled;
      });
    }

    function getStepKeysInOrder() {
      return (state.steps || []).map((s) => s.key);
    }

    function getCurrentStepIndex() {
      return getStepKeysInOrder().indexOf(state.currentStepKey);
    }

    function setStepByIndex(nextIndex) {
      const keys = getStepKeysInOrder();
      if (nextIndex < 0 || nextIndex >= keys.length) return;
      setStep(keys[nextIndex]);
    }

    function ensureNavButtonsMounted() {
      const actions = document.querySelector(".cpb-product-actions");
      if (!actions) return false;

      const firstRow = actions.querySelector(".row");
      if (!firstRow) return false;

      if (firstRow.querySelector(".pj-nav")) return true;

      const nav = document.createElement("div");
      nav.className = "pj-nav";
      nav.innerHTML = `
            <button type="button" class="cpb-actions-btn pj-back"><span>&lt; Back</span></button>
            <button type="button" class="cpb-actions-btn pj-next"><span>Next &gt;</span></button>
            `;

      firstRow.appendChild(nav);

      nav.querySelector(".pj-back").addEventListener("click", () => {
        const idx = getCurrentStepIndex();
        if (idx <= 0) return;

        const prev = getNextRenderableStepKey(idx, -1);
        if (!prev) return;

        setStep(prev.key);
      });

      nav.querySelector(".pj-next").addEventListener("click", () => {
        const idx = getCurrentStepIndex();
        const keys = getStepKeysInOrder();
        if (idx === -1 || idx >= keys.length - 1) return;

        if (!state.stepsUnlocked && idx === 0) return;

        const next = getNextRenderableStepKey(idx, 1);
        if (!next) return;

        setStep(next.key);
      });

      return true;
    }

    function updateNavButtonsUI() {
      const backBtn = document.querySelector(".pj-nav .pj-back");
      const nextBtn = document.querySelector(".pj-nav .pj-next");
      if (!backBtn || !nextBtn) return;

      const idx = getCurrentStepIndex();
      const keys = getStepKeysInOrder();
      const lastIdx = keys.length - 1;

      const backDisabled = idx <= 0;
      backBtn.disabled = backDisabled;
      backBtn.classList.toggle("is-disabled", backDisabled);

      let nextDisabled = idx < 0 || idx >= lastIdx;

      if (!state.stepsUnlocked && idx === 0) nextDisabled = true;

      const currentKey = state.currentStepKey;
      const currentIsComplete =
        currentKey === SUMMARY_STEP.key ? true : isStepComplete(currentKey);
      if (!currentIsComplete) nextDisabled = true;

      const nextRenderable = getNextRenderableStepKey(idx, 1);
      if (!nextRenderable) nextDisabled = true;

      nextBtn.disabled = nextDisabled;
      nextBtn.classList.toggle("is-disabled", nextDisabled);
    }

    function rebuildAndApply() {
      rebuildStoreMap();
      rebuildDomMap();
      buildStepsAndMapsFromStore();
      preloadStepIcons().then(() => {
        mountCustomLabelIntoSteps();
        renderStepBar();
        updateStepButtonsUI();
      });

      if (!state.currentStepKey) {
        state.currentStepKey = getFirstNonSummaryStepKey() || SUMMARY_STEP.key;
      } else {
        const valid =
          state.currentStepKey === SUMMARY_STEP.key ||
          state.stepMap.has(state.currentStepKey);
        if (!valid)
          state.currentStepKey =
            getFirstNonSummaryStepKey() || SUMMARY_STEP.key;
      }

      recomputeUnlock();
      applyStep();
      updateStepsInfoUI();
    }

    function rebuildStoreMap() {
      state.storeById = getStoreCategoriesById();
    }

    function rebuildDomMap() {
      const els = Array.from(
        categoriesContainer.querySelectorAll(".cpb-category")
      );

      const map = new Map();
      const list = [];

      for (const el of els) {
        const id = extractCategoryIdFromClass(el);
        if (!id) continue;

        map.set(id, el);

        const titleEl = el.querySelector(".cpb-category-title");
        const title = titleEl ? titleEl.textContent.trim() : "";

        list.push({ id, el, title });
      }

      state.domById = map;
      state.categories = list;
    }

    function buildStepsAndMapsFromStore() {
      const storeById = state.storeById;
      const stepsByKey = new Map();
      const stepMap = new Map();

      for (const cat of storeById.values()) {
        const metaStepKey = getMetaValue(cat?.metafields, STEP_META_KEYS);
        if (!metaStepKey) continue;

        const stepKey = String(metaStepKey).trim();

        const metaLabel = getMetaValue(cat?.metafields, STEP_LABEL_META_KEYS);
        const stepLabel = metaLabel
          ? String(metaLabel).trim()
          : humanizeStepKey(stepKey);

        const metaOrder = getMetaValue(cat?.metafields, STEP_ORDER_META_KEYS);
        const stepOrder = Number.isFinite(Number(metaOrder))
          ? Number(metaOrder)
          : 999;

        const iconUrl = getMetaValue(cat?.metafields, ICON_META_KEYS);

        if (!stepMap.has(stepKey)) stepMap.set(stepKey, new Set());
        stepMap.get(stepKey).add(cat.id);

        if (!stepsByKey.has(stepKey)) {
          stepsByKey.set(stepKey, {
            key: stepKey,
            label: stepLabel,
            order: stepOrder,
            iconUrl: iconUrl || "",
          });
        } else {
          const s = stepsByKey.get(stepKey);
          if (!s.iconUrl && iconUrl) s.iconUrl = iconUrl;
        }
      }

      const steps = Array.from(stepsByKey.values()).sort(
        (a, b) => a.order - b.order
      );
      steps.push({ ...SUMMARY_STEP });

      state.steps = steps;
      state.stepMap = stepMap;
    }

    function updateActionsVisibility() {
      const actions = document.querySelector(".cpb-product-actions");
      if (!actions) return;

      const isSummary = state.currentStepKey === SUMMARY_STEP.key;

      const rows = Array.from(actions.querySelectorAll(":scope > .row"));
      rows.forEach((row, i) => {
        if (i === 0) {
          row.style.removeProperty("display");
        } else {
          if (isSummary) row.style.removeProperty("display");
          else row.style.display = "none";
        }
      });

      const qty = actions.querySelector(".cpb-quantity");
      if (qty) {
        if (isSummary) qty.style.removeProperty("display");
        else qty.style.display = "none";
      }

      const qtyWrap =
        actions.querySelector(".cpb-quantity-container") ||
        actions.querySelector('[class*="quantity"]');
      if (qtyWrap && qtyWrap !== qty) {
        qtyWrap.style.display = isSummary ? "" : "none";
      }
    }

    function applyStep() {
      updateStepButtonsUI();
      updateNavButtonsUI();

      ensureSummaryMounted();

      const summary = root.querySelector(".pj-summary");

      updateActionsVisibility();

      if (state.currentStepKey === SUMMARY_STEP.key) {
        state.categories.forEach((c) => (c.el.style.display = "none"));

        if (summary) {
          renderSummary();
          summary.style.display = "";
        }
        updateStepsInfoUI();
        return;
      }

      if (summary) summary.style.display = "none";

      const allowedIds = state.stepMap.get(state.currentStepKey) || new Set();
      state.categories.forEach((c) => {
        c.el.style.display = allowedIds.has(c.id) ? "" : "none";
      });

      updateStepsInfoUI();
    }

    function bindEventsOnce() {
      if (window[EVENTS_BOUND_FLAG]) return;
      window[EVENTS_BOUND_FLAG] = true;

      let refreshQueued = false;

      const runRefresh = () => {
        rebuildDomMap();
        recomputeUnlock();
        updateStepButtonsUI();
        updateNavButtonsUI();
        updateStepsInfoUI();

        if (state.currentStepKey === SUMMARY_STEP.key) renderSummary();
      };

      const scheduleRefresh = () => {
        if (refreshQueued) return;
        refreshQueued = true;

        requestAnimationFrame(() => {
          runRefresh();

          setTimeout(() => {
            runRefresh();

            setTimeout(() => {
              runRefresh();
              refreshQueued = false;
            }, 30);
          }, 0);
        });
      };

      document.body.addEventListener(
        "PRODUCT_BUILDER_OPTION_ACTIVATE",
        scheduleRefresh
      );
      categoriesContainer.addEventListener("change", scheduleRefresh, true);
      categoriesContainer.addEventListener("click", scheduleRefresh, true);

      document.body.addEventListener("CPB_ON_OPTIONS_UPDATE", () => {
        rebuildAndApply();
      });
    }
    function isCategoryComplete(catId) {
      const el = state.domById.get(catId);
      if (!el) return false;

      const val = getActiveValueFromCategoryEl(el);
      return !!(val && val.trim());
    }
    function mountCustomLabelIntoSteps() {
      const sub = root.querySelector(".pj-steps-sub");
      if (!sub) return;

      const label = root.querySelector("p.cpb-custom-label");
      if (!label) return;

      if (label.parentElement !== sub) sub.appendChild(label);
    }
    function isStepComplete(stepKey) {
      const ids = state.stepMap.get(stepKey);
      if (!ids || ids.size === 0) return false;

      const domIds = Array.from(ids).filter((id) => state.domById.has(id));
      if (domIds.length === 0) return false;

      return domIds.every(isCategoryComplete);
    }
    function recomputeUnlock() {
      const firstKey = getFirstNonSummaryStepKey();
      state.stepsUnlocked = firstKey ? isStepComplete(firstKey) : true;
    }
    function extractCategoryIdFromClass(el) {
      for (const cls of el.classList) {
        if (cls.startsWith("cpb-category-") && cls !== "cpb-category") {
          return cls.replace("cpb-category-", "");
        }
      }
      for (const cls of el.classList) {
        if (
          cls.includes("--") &&
          cls.length > 10 &&
          !cls.startsWith("sc-") &&
          cls !== "category" &&
          cls !== "active"
        ) {
          return cls;
        }
      }
      return null;
    }
    function cleanTitle(raw) {
      let t = (raw || "").replace(/\u00A0/g, " ").trim();

      t = t.replace(/^select\s*/i, "");
      t = t.replace(/^choose\s*/i, "");
      t = t.replace(/^pick\s*/i, "");
      t = t.replace(/^select(?=[A-Z])/i, "");
      t = t.replace(/^choose(?=[A-Z])/i, "");
      t = t.replace(/^pick(?=[A-Z])/i, "");

      return t.trim();
    }

    function isStepCurrentlyRenderable(stepKey) {
      if (stepKey === SUMMARY_STEP.key) return true;

      const ids = state.stepMap.get(stepKey);
      if (!ids || ids.size === 0) return false;

      for (const id of ids) {
        if (state.domById.has(id)) return true;
      }
      return false;
    }

    function getNextRenderableStepKey(fromIndex, direction = 1) {
      const keys = getStepKeysInOrder();
      let i = fromIndex + direction;

      while (i >= 0 && i < keys.length) {
        const k = keys[i];
        if (isStepCurrentlyRenderable(k)) return { key: k, index: i };
        i += direction;
      }
      return null;
    }
    function getActiveValueFromCategoryEl(catEl) {
      if (!catEl) return "";

      const pickText = (el) =>
        (el?.textContent || "").replace(/\s+/g, " ").trim();

      const checked = catEl.querySelector(
        'input[type="radio"]:checked, input[type="checkbox"]:checked'
      );
      if (checked) {
        const label =
          checked.closest("label") ||
          (checked.id && catEl.querySelector(`label[for="${checked.id}"]`));
        const val = pickText(label) || pickText(checked) || checked.value;
        if (val) return val;
      }

      const ariaPicked = catEl.querySelector(
        '[aria-selected="true"], [aria-checked="true"], [aria-pressed="true"]'
      );
      if (ariaPicked) {
        const val = pickText(ariaPicked);
        if (val) return val;
      }

      const activeEl = catEl.querySelector(
        ".option.active, .active.option, .selected, .is-active, .active, [data-selected='true'], [data-active='true']"
      );
      if (activeEl) {
        const labelInside =
          activeEl.querySelector(".label, .option-label, span, button") ||
          activeEl;
        const val = pickText(labelInside);
        if (val) return val;
      }

      const input = catEl.querySelector("input, textarea");
      if (input && (input.value || "").trim()) return input.value.trim();

      return "";
    }

    function getCategoryByTitleIncludes(substr) {
      const needle = normalizeText(substr);
      return (
        state.categories.find((c) => normalizeText(c.title).includes(needle)) ||
        null
      );
    }

    function ensureSummaryMounted() {
      if (root.querySelector(".pj-summary")) return;

      const summary = document.createElement("div");
      summary.className = "pj-summary";
      summary.style.display = "none";

      categoriesContainer.prepend(summary);
    }

    function renderSummary() {
      const summary = root.querySelector(".pj-summary");
      if (!summary) return;

      const storeById = getStoreCategoriesById();

      const cards = [];

      for (const c of state.categories) {
        const tNorm = normalizeText(c.title);

        if (tNorm.includes("add a sleeve") || tNorm === "sleeve") continue;

        const storeCat = storeById.get(c.id);

        const stepKey = getMetaValue(storeCat?.metafields, STEP_META_KEYS);
        if (!stepKey) continue;

        if (String(stepKey).trim() === "upload_logo") continue;

        const value = getActiveValueFromCategoryEl(c.el);

        cards.push({
          title: cleanTitle(c.title) || "Option",
          value: value || "—",
          stepKey: String(stepKey).trim(),
          stepOrder: Number(
            getMetaValue(storeCat?.metafields, STEP_ORDER_META_KEYS) || 999
          ),
          catId: c.id,
        });
      }

      const addSleeveCat = state.categories.find((c) =>
        normalizeText(c.title).includes("add a sleeve")
      );
      const sleeveCats = state.categories.filter(
        (c) => normalizeText(c.title) === "sleeve"
      );

      if (addSleeveCat) {
        const addSleeveVal = normalizeText(
          getActiveValueFromCategoryEl(addSleeveCat.el)
        );
        const sleeveCatLive =
          sleeveCats.find((c) => getActiveValueFromCategoryEl(c.el)) ||
          sleeveCats[0] ||
          null;

        let sleeveValue = "—";

        if (addSleeveVal === "no") sleeveValue = "No";
        else if (addSleeveVal === "yes") {
          const picked = sleeveCatLive
            ? getActiveValueFromCategoryEl(sleeveCatLive.el)
            : "";
          sleeveValue = picked || "Yes";
        }

        const storeById = getStoreCategoriesById();
        const storeAddSleeve = storeById.get(addSleeveCat.id);

        const stepKey =
          getMetaValue(storeAddSleeve?.metafields, STEP_META_KEYS) ||
          "bottom_sleeve";
        const stepOrder = Number(
          getMetaValue(storeAddSleeve?.metafields, STEP_ORDER_META_KEYS) || 999
        );

        cards.push({
          title: "Sleeve",
          value: sleeveValue,
          stepKey: String(stepKey).trim(),
          stepOrder,
          catId: addSleeveCat.id,
        });
      }

      cards.sort(
        (a, b) => a.stepOrder - b.stepOrder || a.title.localeCompare(b.title)
      );

      summary.innerHTML = `
        <div class="pj-summary-grid">
          ${cards
            .map(
              (x) => `
              <div class="pj-summary-card">
                <div class="pj-summary-card-head">
                  <div class="pj-summary-title">${escapeHtml(x.title)}</div>
                  <button type="button" class="pj-summary-edit" data-step-key="${escapeAttr(
                    x.stepKey
                  )}">Edit</button>
                </div>
                <div class="pj-summary-value">${escapeHtml(x.value)}</div>
              </div>
            `
            )
            .join("")}
        </div>
        `;

      const shouldScroll = false;
      summary.querySelectorAll(".pj-summary-edit").forEach((btn) => {
        btn.addEventListener("click", () => {
          e.preventDefault();
          e.stopPropagation();

          const stepKey = btn.dataset.stepKey;
          if (!stepKey) return;

          setStep(stepKey);

          if (shouldScroll) {
            categoriesContainer.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        });
      });
    }

    function getStoreCategoriesById() {
      const st = CPB?.getStore?.().getState?.();
      const arr = st?.Product?.panels?.[0]?.categories;
      const map = new Map();
      if (!Array.isArray(arr)) return map;

      for (const cat of arr) {
        if (cat?.id) map.set(cat.id, cat);
      }
      return map;
    }

    function getMetaValue(metafields, keys) {
      if (!Array.isArray(metafields) || metafields.length === 0) return null;

      for (const { namespace, key } of keys) {
        const mf = metafields.find((m) => {
          const mk = (m?.key ?? m?.name ?? "").toString();
          const ns = (m?.namespace ?? "").toString();
          if (namespace && ns !== namespace) return false;
          return mk === key;
        });

        if (mf) return mf.value ?? mf.val ?? mf.data ?? null;
      }
      return null;
    }

    function debugReset() {
      window[INIT_FLAG] = false;
      window[EVENTS_BOUND_FLAG] = false;
      observer?.disconnect?.();
      observer = null;
      state = null;
      root = null;
      categoriesContainer = null;
      document.querySelector(".pj-steps")?.remove();
      document.querySelector(".pj-nav")?.remove();
      log("debugReset done");
    }

    return { init, debugReset };
  })();

  async function getCurrentProductHandle() {
    try {
      const pathname = window.location.pathname || "";
      const match = pathname.match(/\/products\/([^/?#]+)/);
      if (match && match[1]) return match[1];

      const cpbUrl =
        CPB?.getStore?.().getState?.()?.Product?.url ||
        CPB?.getStore?.().getState?.()?.Product?.handle;

      if (typeof cpbUrl === "string" && cpbUrl.length) {
        const cpbMatch = cpbUrl.match(/\/products\/([^/?#]+)/);
        if (cpbMatch && cpbMatch[1]) return cpbMatch[1];
        return cpbUrl;
      }

      return null;
    } catch (e) {
      console.error("[CPB DISCLAIMER] getCurrentProductHandle error:", e);
      return null;
    }
  }

  async function loadProductTagsFromShopify() {
    try {
      if (Array.isArray(window.productTagsRaw)) {
        return window.productTagsRaw;
      }

      const handle = await getCurrentProductHandle();

      if (!handle) return [];

      const res = await fetch(`/products/${handle}.js`, {
        credentials: "same-origin",
      });

      if (!res.ok) {
        console.error(
          "[CPB DISCLAIMER] product.js request failed:",
          res.status
        );
        return [];
      }

      const product = await res.json();

      let tags = product?.tags || [];

      if (typeof tags === "string") {
        tags = tags
          .split(",")
          .map((t) => t.trim())
          .filter(Boolean);
      }

      if (!Array.isArray(tags)) tags = [];

      window.productTagsRaw = tags;
      window.hasDisclaimerTag = tags.includes("Disclaimer");

      return tags;
    } catch (e) {
      console.error("[CPB DISCLAIMER] loadProductTagsFromShopify error:", e);
      return [];
    }
  }

  async function productHasDisclaimerTag() {
    try {
      const tags = await loadProductTagsFromShopify();
      const result = Array.isArray(tags) && tags.includes("Disclaimer");
      return result;
    } catch (e) {
      console.error("[CPB DISCLAIMER] productHasDisclaimerTag error:", e);
      return false;
    }
  }

  class CustomAddToCart {
    constructor() {
      const that = this;
      this.setDefaultCartFunction();
      if (!!window._cpb.settings === false) window._cpb.settings = {};
      window._cpb.settings.addToCartOverride = async (data) => {
        await that.addToCartFunction(data);
      };
    }
    setCartFunction(func) {
      this.addToCartFunction = func;
    }

    setDefaultCartFunction() {
      this.addToCartFunction = async (data) => {
        const hasDisclaimer = await productHasDisclaimerTag();

        if (hasDisclaimer && data?.items?.length) {
          data.items.forEach((item, index) => {
            if (!item.properties) item.properties = {};
            item.properties["Disclaimer"] =
              "Accepted during product customization";
          });
        } else {
          console.log("[CPB DISCLAIMER] property injection skipped");
        }

        fetch("/cart/add.js", {
          headers: {
            "content-type": "application/json;charset=UTF-8",
          },
          body: JSON.stringify(data),
          method: "POST",
        })
          .then(async (res) => {
            const text = await res.text();
            if (data.redirect) location.href = "/cart";
          })
          .catch((err) => {
            console.error("[CPB DISCLAIMER] fetch error:", err);
          });
      };
    }
  }

  /**
   * Remove broken ARIA references (WCAG fix)
   * Some CPB elements contain aria-describedby pointing to non-existent IDs (e.g. TooltipContent2),
   * which causes "Broken ARIA reference" errors in accessibility audits (WAVE).
   * This function cleans such attributes safely.
   */
  function removeBrokenAriaReferences() {
    document.querySelectorAll("[aria-describedby]").forEach((el) => {
      const ids = el.getAttribute("aria-describedby").split(" ");

      const validIds = ids.filter((id) => document.getElementById(id));

      if (validIds.length === 0) {
        // remove completely if no valid references exist
        el.removeAttribute("aria-describedby");
      } else {
        // update attribute if only some IDs are invalid
        el.setAttribute("aria-describedby", validIds.join(" "));
      }
    });
  }

  /**
   * Observe DOM changes and auto-remove broken aria-describedby
   * Needed because CPB dynamically mounts components
   */
  function observeBrokenAria() {
    removeBrokenAriaReferences();

    const observer = new MutationObserver(() => {
      removeBrokenAriaReferences();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function init() {
    const customAddToCart = new CustomAddToCart();
    changeLoaderImage.init();
    hideTooltipOnScroll();
    observeBrokenAria();
    // duscounts()
    myRegistry(customAddToCart);

    PJSteps.init();
  }

  function hideTooltipOnScroll() {
    setScrollOnce();

    function setScrollOnce() {
      document.addEventListener(
        "scroll",
        function () {
          hideActiveTooltip();
          setTimeout(setScrollOnce, 1000);
        },
        { once: true }
      );
    }

    function hideActiveTooltip() {
      const tooltip = document.querySelector(".Polaris-PositionedOverlay");
      if (!tooltip) return;
      tooltip.style.display = "none";
    }
  }

  const PJThumbsVisualAlign = (() => {
    const THUMBS_SELECTOR = ".cpb-swiper-thumbnails .swiper-container";

    const boundSwipers = new WeakSet();

    let rafId = null;
    let timeoutOne = null;
    let timeoutTwo = null;
    let timeoutThree = null;
    let observer = null;
    let isGlobalEventsBound = false;

    const clamp = (value, min, max) => {
      return Math.max(min, Math.min(max, value));
    };

    const getNumberCssVar = (element, name, fallback) => {
      const value = window.getComputedStyle(element).getPropertyValue(name);
      const parsed = parseFloat(value);

      return Number.isFinite(parsed) ? parsed : fallback;
    };

    const getThumbsSwiper = () => {
      return document.querySelector(THUMBS_SELECTOR)?.swiper || null;
    };

    const bindSwiperEvents = (swiper) => {
      if (
        !swiper ||
        boundSwipers.has(swiper) ||
        typeof swiper.on !== "function"
      ) {
        return;
      }

      boundSwipers.add(swiper);

      swiper.on("slideChange", scheduleAlign);
      swiper.on("transitionEnd", scheduleAlign);
      swiper.on("slideChangeTransitionEnd", scheduleAlign);
    };

    const align = () => {
      const swiper = getThumbsSwiper();

      if (
        !swiper ||
        !swiper.el ||
        !swiper.wrapperEl ||
        !swiper.slides?.length
      ) {
        return;
      }

      bindSwiperEvents(swiper);

      const thumbsRoot =
        swiper.el.closest(".cpb-swiper-thumbnails") || swiper.el;
      const wrapper = swiper.wrapperEl;
      const slides = Array.from(swiper.slides);

      const activeSlideFromClass = wrapper.querySelector(
        ".swiper-slide-active"
      );
      const activeIndexFromClass = slides.indexOf(activeSlideFromClass);

      const activeIndex = clamp(
        activeIndexFromClass >= 0
          ? activeIndexFromClass
          : swiper.activeIndex || 0,
        0,
        slides.length - 1
      );

      const activeSlide = slides[activeIndex];
      const firstSlide = slides[0];
      const lastSlide = slides[slides.length - 1];

      const containerWidth = swiper.el.clientWidth;
      const currentTranslate = swiper.translate || 0;

      const leftOffset = getNumberCssVar(
        thumbsRoot,
        "--pj-thumbs-left-offset",
        44
      );

      const rightOffset = getNumberCssVar(
        thumbsRoot,
        "--pj-thumbs-right-offset",
        44
      );

      const activeLeft = activeSlide.offsetLeft + currentTranslate;
      const firstLeft = firstSlide.offsetLeft + currentTranslate;
      const lastRight =
        lastSlide.offsetLeft + lastSlide.offsetWidth + currentTranslate;

      /**
       * Usually: active thumbnail starts near the left side,
       * but with a small offset so it does not overlap the left arrow.
       */
      let shift = leftOffset - activeLeft;

      /**
       * Near the true end: do not create empty space on the right.
       * This keeps the last thumbnail near the right side, not centered.
       */
      const minShiftToFillRightSide = containerWidth - rightOffset - lastRight;

      /**
       * Near the true beginning: do not create empty space on the left.
       */
      const maxShiftToFillLeftSide = leftOffset - firstLeft;

      shift = clamp(shift, minShiftToFillRightSide, maxShiftToFillLeftSide);

      wrapper.classList.add("pj-thumbs-visual-align");
      wrapper.style.setProperty("--pj-thumbs-shift", `${shift}px`);
    };

    function scheduleAlign() {
      cancelAnimationFrame(rafId);
      clearTimeout(timeoutOne);
      clearTimeout(timeoutTwo);
      clearTimeout(timeoutThree);

      rafId = requestAnimationFrame(align);

      /**
       * CPB/Swiper sometimes update activeIndex/translate asynchronously.
       * These delayed calls keep the visual correction stable after arrows,
       * thumbnail clicks, option changes, and preview re-renders.
       */
      timeoutOne = setTimeout(align, 80);
      timeoutTwo = setTimeout(align, 250);
      timeoutThree = setTimeout(align, 550);
    }

    const bindGlobalEvents = () => {
      if (isGlobalEventsBound) return;

      isGlobalEventsBound = true;

      document.addEventListener(
        "click",
        (event) => {
          const isArrowClick = event.target.closest(".cpb-preview-arrows-item");
          const isThumbnailClick = event.target.closest(
            ".cpb-swiper-thumbnails .swiper-slide"
          );

          if (isArrowClick || isThumbnailClick) {
            scheduleAlign();
          }
        },
        true
      );

      document.addEventListener("CPB_ON_PRODUCT_MOUNTED", scheduleAlign);
      document.addEventListener("CPB_ON_OPTIONS_UPDATE", scheduleAlign);

      window.addEventListener("resize", scheduleAlign);
      window.addEventListener("load", scheduleAlign);
    };

    const initObserver = () => {
      if (observer) return;

      const root = document.querySelector("#product-builder") || document.body;

      observer = new MutationObserver(() => {
        scheduleAlign();
      });

      observer.observe(root, {
        childList: true,
        subtree: true,
      });
    };

    const init = () => {
      bindGlobalEvents();
      initObserver();
      scheduleAlign();
    };

    return {
      init,
      align,
    };
  })();

  document.addEventListener("CPB_ON_PRODUCT_MOUNTED", () => {
    PJThumbsVisualAlign.init();
  });

  window.addEventListener("load", () => {
    PJThumbsVisualAlign.init();
  });

  setTimeout(() => {
    PJThumbsVisualAlign.init();
  }, 500);
})(jQuery);
